<template lang="pug">
div
  Form(:data="value", :isSubmitting="isSubmitting", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useValueEdit from './useValueEdit'

export default {
  components: {
    Form,
  },
  setup() {
    const { show, update, value, isSubmitting } = useValueEdit()

    onMounted(show)

    return {
      value,
      update,
      isSubmitting,
    }
  },
}
</script>
